import React from 'react';
import '../../index.css'

const Search = ({ searchTerm, setSearchTerm }) => {
    return (
        <input
            type="text"
            placeholder="Buscar..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
        />
    );
};

export default Search;
